import { EventEmitter } from 'eventemitter3';

export default class ThemeService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new ThemeService();
	}

	constructor() {
		this.events = new EventEmitter;
	}

	setTheme(theme) {
		this._theme = theme;
		this.events.emit('themechanged');
	}

	getTheme() {
		return this._theme;
	}
}